import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import React from "react";
import MuiTypography from "../MuiTypography";
import MuiBox from "../MuiBox";
import UncheckedIcon from "assets/images/svg-icons/radioUncheckedIcon.svg";
import CheckedIcon from "assets/images/svg-icons/radioCheckedIcon.svg";

const RadioGroupComponent = ({
  label,
  options,
  value,
  onChange,
  rowgap,
  mainLabelColor,
  radioLabelColor,
  descriptionColor,
  isBold = false,
  ...rest
}) => {
  const handleChange = (event) => {
    console.log(event, "test");
    onChange(event);
  };

  return (
    <FormControl>
      <FormLabel id="demo-row-radio-buttons-group-label" sx={{ mb: "8px" }}>
        {typeof label === "string" ? (
          <MuiTypography variant="20" color={mainLabelColor}>
            {label}
          </MuiTypography>
        ) : (
          label
        )}
      </FormLabel>
      <RadioGroup
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        value={value}
        onChange={(e) => handleChange(e)}
        sx={{ rowGap: rowgap }}
        {...rest}
      >
        {options?.map((item) => {
          return (
            <FormControlLabel
              sx={{
                alignItems: "flex-start",
                m: 0,
                width: "fit-content",
                "& .MuiFormControlLabel-label": { mt: "5px" },
              }}
              key={item?.value}
              value={item?.value}
              control={
                <Radio
                  icon={
                    <MuiBox sx={{ height: "16px", width: "16px" }}>
                      <img src={UncheckedIcon} alt="" className="img-full" />
                    </MuiBox>
                  }
                  checkedIcon={
                    <MuiBox sx={{ height: "16px", width: "16px" }}>
                      <img src={CheckedIcon} alt="" className="img-full" />
                    </MuiBox>
                  }
                  value={item?.value}
                  disabled={item?.disabled || rest?.disabled}
                />
              }
              label={
                <MuiBox sx={{ display: "flex", flexDirection: "column" }}>
                  <MuiTypography
                    variant="16"
                    fontWeight={isBold ? 600 : 400}
                    color={radioLabelColor}
                  >
                    {item?.label}
                  </MuiTypography>
                  {item?.description && (
                    <MuiTypography variant="14" color={descriptionColor}>
                      {item?.description}
                    </MuiTypography>
                  )}
                </MuiBox>
              }
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
};

export default RadioGroupComponent;
